<template>
  <div id="menuBrand">
    <div class="flex-col flex__center">
      <img src="../../assets/img/new-symbol/logo.png" alt="" style="height: 45px;"/>
      <!-- <span class="font-size__small margin-top-10 color__smoke"
      >vxxxx.0
      </span> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "menu-brand"
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/menu-left/menu-brand.vue